<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :loading="loading"
      :items="documents"
      :items-per-page="10"
      :disable-sort="$vuetify.breakpoint.smAndDown"
      :footer-props="{'items-per-page-text': 'Số Hồ Sơ một trang'}"
      v-bind="this.$attrs"
    >
      <template v-slot:[`item.createdAt`]="{item}">
        {{ formatCreatedAt(item.createdAt) }}
      </template>

      <template v-slot:[`item.status`]="{item}">
        {{ translateStatus(item.status) }}
      </template>
      <template v-slot:[`footer.page-text`]="items">
        Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
      </template>
    </v-data-table>
  </div>
</template>

<script>
const originHeaders = [
  {
    text: 'Số điện thoại',
    value: 'phone',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Tên',
    value: 'buyerName',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Email',
    value: 'email',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Học sinh',
    value: 'data',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Ghi chú',
    value: 'note',
    align: 'left',
    sortable: false,
    show: true
  }
]

import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'

export default {
  props: {
    documents: Array
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      Leads: []
    }
  },

  methods: {
    ...mapActions('lead', ['fetchLeads']),

    formatCreatedAt(date) {
      return moment(date).format('DD/MM/YYYY')
    },

    translateStatus(status) {
      const translation = {
        noContact: 'Chưa liên hệ',
        appointmentSet: 'Đã đặt lịch hẹn',
        productVerified: 'Đã tư vấn trực tiếp',
        succeed: 'Đã đăng ký xét tuyển',
        failed: 'Thất bại'
      }
      return translation[status] || status
    }
  }
}
/* eslint-enable no-unused-vars */
</script>
